
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-and-insights/in-the-news",
      function () {
        return require("private-next-pages/news-and-insights/in-the-news.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-and-insights/in-the-news"])
      });
    }
  